import { MessageSquarePlus, Trash2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import type { AgentConversationSummary } from "@/types"

export function ConversationHistory({
  conversations,
  selectedId,
  onNew,
  onSelect,
  onDelete,
}: {
  conversations: AgentConversationSummary[]
  selectedId: number | null
  onNew: () => void
  onSelect: (id: number) => void
  onDelete: (conversation: AgentConversationSummary) => void
}) {
  return (
    <aside className="bg-muted/30 flex max-h-44 shrink-0 flex-col border-b md:max-h-none md:w-52 md:border-r md:border-b-0">
      <div className="p-3">
        <Button className="w-full" variant="outline" onClick={onNew}>
          <MessageSquarePlus />
          New chat
        </Button>
      </div>
      <nav
        aria-label="Conversation history"
        className="overflow-y-auto px-2 pb-3"
      >
        {conversations.length === 0 ? (
          <p className="text-muted-foreground px-2 py-3 text-sm">
            Your conversations will appear here.
          </p>
        ) : (
          <ul className="space-y-1">
            {conversations.map((conversation) => (
              <li
                key={conversation.id}
                className="group flex items-center gap-1"
              >
                <button
                  type="button"
                  className={cn(
                    "hover:bg-accent focus-visible:ring-ring min-w-0 flex-1 rounded-md px-2 py-2 text-left text-sm focus-visible:ring-2 focus-visible:outline-none",
                    selectedId === conversation.id && "bg-accent",
                  )}
                  aria-current={
                    selectedId === conversation.id ? "page" : undefined
                  }
                  onClick={() => onSelect(conversation.id)}
                >
                  <span className="block truncate">{conversation.title}</span>
                </button>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon-sm"
                  aria-label={`Delete ${conversation.title}`}
                  onClick={() => onDelete(conversation)}
                >
                  <Trash2 />
                </Button>
              </li>
            ))}
          </ul>
        )}
      </nav>
    </aside>
  )
}
